import { EDITOR_FIELD_CATALOG, EDITOR_NAME_PART_KEYS } from '@messenger/lotus'

export const fieldLabel = (key: string): string =>
  EDITOR_FIELD_CATALOG.find((f) => f.key === key)?.label ?? key

export const namePartLabel = (part: string): string => {
  const key = EDITOR_NAME_PART_KEYS[part]
  return key === undefined ? part : fieldLabel(key)
}
